import { SplashVideo } from '@/components/organisms/SplashVideo';
import { useUIColors } from '@/core/hooks';
import { logger } from '@/core/logger';
import * as SplashScreen from 'expo-splash-screen';
import React, { useEffect } from 'react';
import { StyleSheet, View } from 'react-native';

// Prevent the splash screen from auto-hiding before App component declaration
SplashScreen.preventAutoHideAsync();

export interface SplashScreenComponentProps {
    onVideoComplete?: () => void;
}

export const SplashScreenComponent = React.memo(function SplashScreenComponent({ onVideoComplete }: SplashScreenComponentProps) {
    const colors = useUIColors();

    useEffect(() => {
        // Hide the native splash screen after our custom splash is ready
        const hideNativeSplash = async () => {
            try {
                await SplashScreen.hideAsync();
            } catch (error) {
                logger.warn('SplashScreenComponent', 'Failed to hide native splash screen:', error);
            }
        };

        hideNativeSplash();
    }, []);

    return (
        <View style={[styles.container, { backgroundColor: colors.backgroundSplash }]}>
            <SplashVideo style={styles.video} />
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    video: {
        width: '100%',
        height: '100%',
        alignSelf: 'center',
    },
});

export default SplashScreenComponent;
